import request from './http';

// 查询特殊部门权限
export const getDepartInfoList = ( data ) => {
    return request({
        url: '/auth/access/findSpecialAllocationDepartInfo?companyId='+data.companyId+"&userCode="+data.userCode + "&userId=" + data.userId,
        method: 'get',
    })
}

//查询部门权限
export const getDepartInfoLists = (data) => {
    return request({
        url:'/auth/depart/findAllocationDepartInfo?companyId=' + data.companyId + "&userCode=" + data.userCode,
        method:'get'
    })
}
//角色管理查询部门权限
export const getDepartInfoListed = (data) => {
    return request({
        url:'auth/access/findNormalAllocationDepartInfo?companyId=' + data.companyId + "&userCode=" + data.userCode + "&roleId=" +data.roleId,
        method:'get'
    })
}
// 保存部门信息
export const addDepart = ( data ) => {
    return request({
        url: '/auth/depart/addDepartInfo',
        method: 'post',
        data
    })
}

// 删除部门信息
export const deleteDepart = ( data ) => {
    return request({
        url: '/auth/depart/deleteDepart?companyId='+data.companyId+"&groupId="+data.groupId,
        method: 'get',
        data
    })
}

// 修改部门信息
export const changeDepart = ( data ) => {
    return request({
        url: '/auth/depart/modifyDepartInfo',
        method: 'post',
        data
    })
}

// 查询角色数据权限分配的部门数信息
export const getRoleAuthDepartInfo = data => {
    return request({
        url: '/auth/depart/findRoleAuthDepartInfo?companyId='+data.companyId+"&roleId="+data.roleId+"&userCode="+data.userCode,
        method: 'get'
    })
}
